import { CallbackSnackbar } from 'app-shared/lib/components/feedback/callback-snackbar';
import { SnackbarService } from 'ui-components';

/**
 * Show message when progressive web app is updated
 */
const initPwa = (): void => {
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator && window.workbox !== undefined) {
    const workbox = window.workbox;

    // A common UX pattern for progressive web apps is to show a banner when a service worker has updated and waiting to install.
    // NOTE: MUST set skipWaiting to false in next.config.js pwa object
    // https://developers.google.com/web/tools/workbox/guides/advanced-recipes#offer_a_page_reload_for_users
    const promptNewVersionAvailable = () => {
      if (process.env.NEXT_PUBLIC_SHOW_APP_UPDATED_MESSAGE == 'true') {
        // `event.wasWaitingBeforeRegister` will be false if this is the first time the updated service worker is waiting.
        // When `event.wasWaitingBeforeRegister` is true, a previously updated service worker is still waiting.

        SnackbarService.showSnackbar((onClose) => (
          <CallbackSnackbar
            message="Mise à jour réussie."
            onClose={() => onAppUpdatedSnackbarClose(onClose, workbox)}
          />
        ));
      } else {
        reloadPageOnControlling(workbox);
      }
    };

    workbox.addEventListener('waiting', promptNewVersionAvailable);

    // never forget to call register as auto register is turned off in next.config.js
    workbox.register();
  }
};

/**
 * Event fired when app updated message closed
 * @param onClose the close callback
 * @param workbox the service worker instance
 */
const onAppUpdatedSnackbarClose = (onClose: () => void, workbox) => {
  onClose();
  reloadPageOnControlling(workbox);
};

/**
 * Reloads page when controlling event is catched
 * @param workbox the service worker
 */
const reloadPageOnControlling = (workbox) => {
  workbox.addEventListener('controlling', () => {
    window.location.reload();
  });

  // Send a message to the waiting service worker, instructing it to activate.
  workbox.messageSkipWaiting();
};

export default initPwa;
